var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4027 10.2083C9.20217 9.75246 8.24737 8.79766 7.7915 7.59718L3.22377 14.1633L3.83654 14.7761L10.4027 10.2083ZM7.55157 5.31541C7.88131 3.15503 9.74729 1.5 11.9998 1.5C14.4851 1.5 16.4998 3.51472 16.4998 6C16.4998 8.25253 14.8448 10.1185 12.6844 10.4483L3.66311 16.7239L1.27588 14.3367L7.55157 5.31541ZM14.6411 7.42374C14.8699 7.00013 14.9998 6.51524 14.9998 6C14.9998 4.34315 13.6567 3 11.9998 3C11.4796 3 10.9903 3.13242 10.5638 3.36539C10.7906 4.07334 11.571 5.26048 12.1552 5.84467C12.7298 6.41932 13.8964 7.18222 14.6411 7.42374ZM13.5246 8.58414C13.0778 8.84836 12.5565 9 11.9998 9C10.343 9 8.99983 7.65685 8.99983 6C8.99983 5.44833 9.14873 4.93144 9.40855 4.48733C9.82606 5.3753 10.496 6.30682 11.0945 6.90533C11.6853 7.49617 12.6252 8.16454 13.5246 8.58414Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetLive);
export default __webpack_public_path__ + "static/media/SET-Live.22b7821c.svg";
export { ForwardRef as ReactComponent };